import clsx from "clsx";
import { useEffect, useState, useRef } from "react";
import OpeningAudio from "@/assets/music/melati-suci.mp3"
import LoadingEngrave100 from "@/assets/imgs/loading-engrave-100w.webp"
import LoadingEngrave200 from "@/assets/imgs/loading-engrave-200w.webp"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeHigh, faVolumeXmark } from "@fortawesome/free-solid-svg-icons";
import GeneralLayout from "@/layouts/General";
import MonkeyAnimationComponent from "./MonkeyAnimation";
import { useGlobalContext } from "@/global/GlobalContext";
import Loader from "../../components/Loader";

const Home = () => {
  const { loading, setLoading, isPlaying, setIsPlaying } = useGlobalContext()
  const [canClick, setCanClick] = useState(false)
  let progress = 0;
  const mediaLg = window.matchMedia("(min-width: 1024px)")
  const openingAudio = useRef(null)

  useEffect(() => {
    const progressBarFill = document.querySelector(".progress-bar-fill");
    const clickText = document.getElementById("clickText")
    const updateProgressBar = () => {
      progress += 1;
      progressBarFill.style.width = `${progress}%`;
      if (progress < 100) {
        setTimeout(updateProgressBar, 2);
      }
    };

    updateProgressBar();

    const timer = setTimeout(() => {
      clickText.classList.toggle("exit")
      clickText.classList.toggle("initial")
      if (mediaLg.matches) document.getElementById("bg").classList.add("cursor-pointer")
      setCanClick(true)
    }, 3000)

    // TODO: cek amankah?
    return () => clearTimeout(timer)
  }, [])

  const removeBG = () => {
    if (canClick) {
      setLoading("exit")
      if (openingAudio.current) {
        openingAudio.current.play().then(() => {
          setIsPlaying(true);
        }).catch(error => {
          console.error("Audio playback failed:", error);
        });
      }
    }
  }

  const muteAudio = () => {
    if (isPlaying) {
      openingAudio.current.pause()
    } else {
      openingAudio.current.play()
    }
    setIsPlaying(!isPlaying)
  }

  return (
    <>
      {/* opening section */}
      <div id="bg" onClick={() => removeBG()} className={clsx("fixed z-50 bg-[#6c5f58] h-screen w-full flex justify-center items-center", loading)}>
        {/* <div className="">
          <img src={OptionLogo} width="100" height="100" className="w-1/5 mx-auto" />
          <div className="progress-bar mx-auto mt-4">
            <div className="progress-bar-fill"></div>
          </div>
        </div> */}
        {/* TODO: coba cek, apakah useEffect di atas (yg ngambil query berdasarkan class progress-bar-fill jalan) */}
        <Loader>
          <div className="progress-bar mx-auto mt-4">
            <div className="progress-bar-fill"></div>
          </div>
        </Loader>
        <div id="clickText" className="absolute bottom-[100px] lg:bottom-8 exit justify-center">
          <div className="text-center">
            <span className="font-headlines text-[#b99a59] text-base leading-4">Click Anywhere</span>
            <img
              src={LoadingEngrave100}
              srcSet={`${LoadingEngrave100} 100w, ${LoadingEngrave200} 200w`}
              sizes="100px"
              width="100"
              height="18"
              loading="eager"
              decoding="async"
              alt="Loading ornament"
            />
          </div>
        </div>
      </div>
      <GeneralLayout bgColor="bg-white">
        <MonkeyAnimationComponent loadingStatus={loading} />
      </GeneralLayout>
      <div className="fixed z-20 bg-white bottom-6 lg:bottom-8 right-6 p-2 rounded-full">
        <button onClick={muteAudio} aria-label={isPlaying ? "Mute audio" : "Unmute audio"}>
          <FontAwesomeIcon icon={!isPlaying ? faVolumeXmark : faVolumeHigh} size="lg" style={{ color: "#b99a59" }} />
        </button>
      </div>
      <audio ref={openingAudio} src={OpeningAudio}></audio>
    </>
  )
}

export default Home
